module.exports = __webpack_public_path__ + "static/media/icon-photo.12d66b31.svg";